/**
 * Counts how often a proof-mode line needed textLength to match InDesign's width.
 * A high ratio means the served fonts or the tracking maths disagree with InDesign.
 */
export interface FidelityStats { lines: number; adjusted: number; maxDelta: number; sumAbsDelta: number; positioned: number }

const stats: FidelityStats = { lines: 0, adjusted: 0, maxDelta: 0, sumAbsDelta: 0, positioned: 0 };
let pending = 0;

/** Tabbed and justified lines are placed word by word, so they never need textLength. */
export function recordPositioned(): void {
  stats.positioned += 1;
  pending += 1;
}

export function recordLine(delta: number, adjusted: boolean): void {
  stats.lines += 1;
  pending += 1;
  if (adjusted) stats.adjusted += 1;
  const abs = Math.abs(delta);
  stats.sumAbsDelta += abs;
  if (abs > stats.maxDelta) stats.maxDelta = abs;
}

export function fidelityStats(): FidelityStats { return { ...stats }; }

export function resetFidelity(): void {
  stats.lines = 0; stats.adjusted = 0; stats.maxDelta = 0; stats.sumAbsDelta = 0; stats.positioned = 0; pending = 0;
}

/** Log the running tally once per render pass (call from an effect after the spread has rendered). */
export function flushFidelityLog(label: string, log: (msg: string) => void = (m) => console.info(m)): void {
  if (pending === 0) return;
  pending = 0;
  const pct = stats.lines ? Math.round((stats.adjusted / stats.lines) * 100) : 0;
  log(`[fidelity] ${label}: textLength applied to ${stats.adjusted} of ${stats.lines} left-aligned lines (${pct}%), max delta ${stats.maxDelta.toFixed(2)} pt, mean ${(stats.lines ? stats.sumAbsDelta / stats.lines : 0).toFixed(2)} pt; ${stats.positioned} tabbed or justified lines placed word by word`);
}
